import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMeasure from 'react-use-measure';
import { pxToRem } from 'src/common/utils/fonts';

type GraphLegendProps = {
  topLabel: string;
  bottomLabel: string;
  axisHeight: number;
};

export const GraphLegend: React.FC<GraphLegendProps> = ({
  topLabel,
  bottomLabel,
  axisHeight = 35,
}) => {
  const [root, bounds] = useMeasure();

  return (
    <Box height={'100%'} ref={root}>
      <Box
        sx={{
          position: 'absolute',
          top: pxToRem((bounds.height - axisHeight) / 4),
          left: pxToRem(24),
          transform: 'translateY(-50%)',
        }}
      >
        <Typography variant="text5" color="text.primary">
          {topLabel}
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: pxToRem((3 * (bounds.height - axisHeight)) / 4),
          left: pxToRem(24),
          transform: 'translateY(-50%)',
        }}
      >
        <Typography variant="text5" color="text.primary">
          {bottomLabel}
        </Typography>
      </Box>
    </Box>
  );
};
